// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3908b8fb","239":"2dfc146d","453":"ca532971","455":"7979c4a4"}[chunkId] + ".chunk.js";
};